module.exports = __webpack_public_path__ + "img/06.74a1eb71.jpg";